<button [@openClose]="variantOpen" [@action]="variantAction" (click)="onClick($event)" (dblclick)="onDblClick($event)">
    <i class="fa fa-times-circle" aria-hidden="true"></i><span><ng-content></ng-content></span>
</button>